import {
  type PortalFeatureFlagRegistry,
  defineNonFrontendPortalFeatureFlag,
  definePortalFeatureFlag,
} from './featureFlagDefinition';

export const PortalFeatureFlags = {
  // Datadog flags
  menuV3_enableQa: definePortalFeatureFlag('datadog', 'menuV3_enableQa', 'boolean'),
  menuV3_externalIdInvalidator: definePortalFeatureFlag(
    'datadog',
    'menuV3_externalIdInvalidator',
    'boolean'
  ),

  // Harness flags
  sampleHarnessFlag: definePortalFeatureFlag('harness', 'sampleHarnessFlag', 'boolean'),
  accessEntitlementsV2Page: definePortalFeatureFlag(
    'harness',
    'accessEntitlementsV2Page',
    'boolean'
  ),
  liveOverviewReportHomepage: definePortalFeatureFlag(
    'harness',
    'liveOverviewReportHomepage',
    'boolean'
  ),
  ordersReport_redirectHeatmap: definePortalFeatureFlag(
    'harness',
    'ordersReport_redirectHeatmap',
    'boolean'
  ),

  // Org-keyed Harness flags (traffic type org_id, targetingKey = orgId).
  // See docs/005-org-keyed-feature-flag-evaluation-for-harness-split-segments.md.
  showMenuListingV3Org: definePortalFeatureFlag(
    'harnessWithOrgIdTargetingKey',
    'showMenuListingV3Org',
    'boolean'
  ),
  menuV3_enableEmptyNameValidation: definePortalFeatureFlag(
    'harnessWithOrgIdTargetingKey',
    'menuV3_enableEmptyNameValidation',
    'boolean'
  ),
  menuV3_enableMobileMenuEditor: definePortalFeatureFlag(
    'harnessWithOrgIdTargetingKey',
    'menuV3_enableMobileMenuEditor',
    'boolean'
  ),
  flipdishAssistant: definePortalFeatureFlag('harness', 'flipdishAssistant', 'boolean'),
  aiMarketing: definePortalFeatureFlag('harness', 'aiMarketing', 'boolean'),

  // For any NonFrontend Portal feature flag you define here, you must also add it to the NONFRONTEND_FEATURE_FLAG_NAMES array in the harnessProvider.ts file.
  backend_menu_shouldAssignMenuToStoreFromOomEvents: defineNonFrontendPortalFeatureFlag(
    'harnessWithOrgIdTargetingKey',
    'backend_menu_shouldAssignMenuToStoreFromOomEvents',
    'boolean'
  ),
} as const satisfies PortalFeatureFlagRegistry;
